import type { Components } from "@mui/material/styles";
import { getContrastColor } from "./utils";

export const MuiRadio: Components["MuiRadio"] = {
  styleOverrides: {
    root: {
      zIndex: 1,
      "&::before": {
        content: "''",
        position: "absolute",
        display: "inline-block",
        borderRadius: "50%",
        zIndex: -1,
      },
      // "&.Mui-checked": {
      //   "&::before": {
      //     width: "18px",
      //     height: "18px",
      //     background: getContrastColor(),
      //   },
      // }
    },
  },
};
